import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { environment } from "../../environments/environment";
import { firstValueFrom } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { LogoResponse } from 'dci-service-shared';

/** Service that handles global interactions with SurveyJS and survey routing */
@Injectable({
	providedIn: 'root'
})
export class LogoService {
	private _currentLogo:string;

	constructor(private http:HttpClient) {
	}

	get currentLogo() {
		return this._currentLogo;
	}

	set currentLogo(logo:string) {
		this._currentLogo = logo;
	}

	static async resolveLogo(route:ActivatedRouteSnapshot):Promise<boolean> {
		const service = inject(LogoService);
		try {
			if(!service.currentLogo) {
				const response = await firstValueFrom(
					service.http.get<LogoResponse>(`${environment.apiUrl}/dci/${route.paramMap.get("surveyId")}/logo`));
				service.currentLogo = response.url;
			}
		} catch(e) {
			console.error("Failed to load logo for org", e);
		}
		return true;
	}
}
